import React from 'react'

export function SignInOidc() {
  return <div>Signing you in</div>
}
